import { useState, useEffect } from 'react';
import useAuth from '@jetshop/core/components/AuthContext/useAuth';
import { useQuery } from 'react-apollo';
import customerIdQuery from './components/Gamifiera/CustomerIdQuery.gql';

export const useFavoriteStore = () => {
  const [favoriteStore, setFavoriteStore] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { loggedIn } = useAuth();

  // Använd exakt samma query som GamifieraContext
  const { data: customerData, loading: customerLoading } = useQuery(
    customerIdQuery,
    {
      skip: !loggedIn,
      errorPolicy: 'ignore',
      fetchPolicy: 'no-cache'
    }
  );

  useEffect(() => {
    const fetchFavoriteStore = async () => {
      if (!loggedIn || !customerData?.customer?.externalId || customerLoading) {
        setFavoriteStore(null);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const url = `/api/customer_favorite_store?externalId=${encodeURIComponent(
          customerData.customer.externalId
        )}`;

        const response = await fetch(url);

        const data = await response.json();

        if (response.ok) {
          setFavoriteStore(data.favoriteStore);
        } else {
          setError(data.error);
        }
      } catch (err) {
        setError('Failed to fetch favorite store');
      } finally {
        setLoading(false);
      }
    };

    fetchFavoriteStore();
  }, [loggedIn, customerData?.customer?.externalId, customerLoading]);

  return { favoriteStore, loading, error };
};
